import { BrowserRouter as Router } from 'react-router-dom';
import MainRoute from './components/core/MainRoutes';
import { CoreContextProvider } from './components/core/CoreContextProvider';
import AuthContextProvider from './components/core/AuthContextProvider';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <Router>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <CoreContextProvider>
        <AuthContextProvider>
          <MainRoute />
        </AuthContextProvider>
      </CoreContextProvider>
    </Router>
  );
}
export default App;
